import React from 'react';

const Fieldset = ({ children }) => (
    <fieldset>{children}</fieldset>
);

export default Fieldset;
